import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "vi"],
    debug: false,
    fallbackLng: "vi",
    lng: localStorage.getItem("__Neo-Pay-language") ? "vi" : "en",
    ns: ["translation"],
    defaultNS: "translation",
    detection: {
      order: ["path", "cookie", "htmlTag"],
      caches: ["cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/languages/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
